import React from 'react';
import {Link} from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';


function Acerca(props) {
  const signout = () => {
    props.setAuthentication(false);
  }
  
  return (
    <div className ="acerca.root">
    
    <h1>Acerca de Nosotros</h1>
    <h3> Integrantes: </h3>
          <Grid container spacing={3}>
          
        <Grid item xs>
        <img   src="photo1.jpeg" className="image"></img>
         <h5> Lourdes Barreto </h5>
          
          
        </Grid>
        <Grid item xs>
         <img   src="photo2.jpeg" className="image"></img>
         <h5> Marvin Henriquez </h5>
          
         
        </Grid>
        <Grid item xs>
        <img   src="photo3.jpeg" className="image"></img>
          <h5> Stevens correa </h5>
          
          
        </Grid>
      </Grid>
      
        
        
        
        

        <p><Link to="/">Regresar</Link></p>
    </div>
  );
}

export default Acerca;
